import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getToken } from "../../features/user/UserAvatar";
import { error, failedResponse, getBackendUrl, loaded, loading, LoadStateInfo, notStarted } from "../common";
import { schoolDelete, schoolInsert, schoolUpdate } from "./schoolInsUpdSlice";
import { SchoolInfo } from "./schoolSlice";

export interface SchoolsState {
  state: LoadStateInfo;
  list?: SchoolInfo[];
}

const initialState: SchoolsState = {
  state: notStarted(),
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RetrieveSchoolsRequest {}

export const retrieveSchools = createAsyncThunk(
  "retrieveSchools",
  async (params: RetrieveSchoolsRequest, thunkAPI) => {
    console.debug("retrieve schools");

    const response = await fetch(`${getBackendUrl()}/api/school/list`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const schoolsSlice = createSlice({
  name: "school",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.list = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveSchools.pending, (state/* , action */) => {
        state.state =  loading();
        state.list = undefined;
      })
      .addCase(retrieveSchools.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
      })
      .addCase(retrieveSchools.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(schoolInsert.fulfilled, (state/* , action */) => {
        state.state = notStarted();
      })
      .addCase(schoolUpdate.fulfilled, (state/* , action */) => {
        state.state = notStarted();
      })
      .addCase(schoolDelete.fulfilled, (state/* , action */) => {
        state.state = notStarted();
      })
      ;
    },
});

// export const { } = schoolsSlice.actions;

export const selectSchools = (state: RootState) => state.schools;

export default schoolsSlice.reducer;
